import React from 'react';

const BlockTitle = ({
    className, children
}) => (
    <div className={'mb-2 text-muted fw-bold text-uppercase ' + (className || '')}>{children}</div>
);

export default BlockTitle;